import TeacherEdition from './TeacherEdition';

export default TeacherEdition;
